export interface RegionIdentifiable {
  identifiable: boolean;
}

export interface Region {
  countryIso: string;
}

export const DefaultRegion: Region = {
  countryIso: 'NZ',
};

export interface Language {
  language: string;
}

const REGION_STORAGE_KEY = 'countryIso';
const LANGUAGE_STORAGE_KEY = 'languageGroup';
const REGION_IDENTIFIABLE_STORAGE_KEY = 'regionIdentifiable';

/**
 * Retrieves the user's selected region from local storage.
 */
export function getRegion(): Region | undefined {
  const region = window.localStorage.getItem(REGION_STORAGE_KEY);

  if (region) {
    return { countryIso: region };
  }
}

export function getRegionIdentifiable(): RegionIdentifiable | undefined {
  const regionIdentifiable = window.localStorage.getItem(
    REGION_IDENTIFIABLE_STORAGE_KEY,
  );

  return regionIdentifiable
    ? { identifiable: JSON.parse(regionIdentifiable) }
    : undefined;
}

/**
 * Persists the user's selected region to local storage.
 */
export function setRegion(region: Region): void {
  window.localStorage.setItem(REGION_STORAGE_KEY, region.countryIso);
}

/**
 * Persists the user's selected language to local storage.
 */
export function setLanguage(language: Language): void {
  window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language.language);
}

/**
 * Persists whether the users region was successfully detected, or whether they are on the fallback region, to local storage.
 */
export function setRegionIdentifiable(
  regionIdentifiable: RegionIdentifiable,
): void {
  window.localStorage.setItem(
    REGION_IDENTIFIABLE_STORAGE_KEY,
    JSON.stringify(regionIdentifiable.identifiable),
  );
}
